import React from 'react'
import { CircularProgress } from '@material-ui/core'

export const Loading = ({ size }) => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <CircularProgress size={size || 50} />
  </div>
)
